module.exports = __webpack_public_path__ + "static/media/all-energy.78d8e9ad.mp3";